export const FIELDS_DESCRIPTOR = {
  'tecnica': { restricted: true },
  'indicazioni_uso': { autocomplete: true, restrictionsIssuer: true },
  'materiale': { extraInfo: true },
  'materia_prima': { extraInfo: true },
  'colore': {}
}
